// extracted by mini-css-extract-plugin
export default {"mainContainer":"Education_mainContainer__OaMEa","upperWrapper":"Education_upperWrapper__3zz7-","bottomWrapper":"Education_bottomWrapper__NBG-k"};